import { useAuth } from "@/hooks/useAuth"
import { useEditMode } from "@/contexts/EditModeContext"
import {Pencil, Save, X, Loader2, PencilOff, AlertCircle} from 'lucide-react'

export default function AdminEditToolbar() {
  const { isAdmin, isAuthenticated } = useAuth()
  const { isEditMode, toggleEditMode, pendingEdits, saveAllEdits, discardEdits, isSaving, contentEdits } = useEditMode()

  if (!isAuthenticated || !isAdmin) return null

  // Compter toutes les modifications en attente
  const unsavedCount = pendingEdits.length

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-3">
      {/* Indicateur de modifications en attente */}
      {isEditMode && unsavedCount > 0 && (
        <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-amber-500/10 border border-amber-500/30 backdrop-blur-xl shadow-lg animate-fade-in-up">
          <AlertCircle className="w-4 h-4 text-amber-400" />
          <span className="text-xs font-medium text-amber-300">
            {unsavedCount} modification{unsavedCount > 1 ? "s" : ""} en attente
          </span>
        </div>
      )}

      {/* Barre d'actions */}
      <div className="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-900/95 border border-slate-700/60 backdrop-blur-xl shadow-2xl shadow-slate-950/50">
        {isEditMode ? (
          <>
            {/* Bouton Sauvegarder */}
            <button
              onClick={saveAllEdits}
              disabled={isSaving}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-emerald-500/20 border border-emerald-500/40 text-emerald-400 text-sm font-medium hover:bg-emerald-500/30 transition-all disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {isSaving ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Save className="w-4 h-4" />
              )}
              Sauvegarder
            </button>

            {/* Bouton Annuler */}
            <button
              onClick={discardEdits}
              disabled={isSaving}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-red-500/10 border border-red-500/30 text-red-400 text-sm font-medium hover:bg-red-500/20 transition-all disabled:opacity-40"
            >
              <X className="w-4 h-4" />
              Annuler
            </button>

            {/* Bouton désactiver */}
            <button
              onClick={toggleEditMode}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-800 border border-slate-600/50 text-slate-300 text-sm font-medium hover:bg-slate-700 transition-all"
            >
              <PencilOff className="w-4 h-4" />
            </button>
          </>
        ) : (
          <button
            onClick={toggleEditMode}
            className="flex items-center gap-2.5 px-5 py-2.5 rounded-xl bg-cyan-500/20 border border-cyan-500/40 text-cyan-400 text-sm font-semibold hover:bg-cyan-500/30 hover:scale-105 transition-all"
          >
            <Pencil className="w-4 h-4" />
            Modifier le site
          </button>
        )}
      </div>
    </div>
  )
}
